import { MessageService } from 'common/service/message/service';

import { preactConnectStore } from '../preact/connect-store';
import { MessagePropsInterface } from './props.interface';
import { MessageTemplate } from './template';
import { MessageViewStore } from './view-store';

export const MessageComponent = preactConnectStore<MessageViewStore, MessagePropsInterface>(MessageService, (store) =>
  store.getState()
)(MessageTemplate);
